import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=group&instance=${instance}`
    }

    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        sectionCategory: "group",
        slogan: '',
        pageTitle: '提升经营',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: '提升收入',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/经营案例/提升收入'),
                path: "经营案例/提升收入"
            },
            {
                name: '节省成本',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/经营案例/节省成本'),
                path: "经营案例/节省成本"
            },
            {
                name: '改进服务 ',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/经营案例/改进服务'),
                path: "经营案例/改进服务",
            },
            {
                name: '优化人资',
                img: '/icons/趋势分析.svg',
                background: 'black',
                url: makeUrl('/内容文件/经营案例/优化人资'),
                path: "经营案例/优化人资"
            },
        ]
    }]
}